import ReactExport from "react-export-excel";
import React from "react";
import { Dropdown } from "react-bootstrap";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const DailyReportsExcelToRenderOverallComponent = (data, filename) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Daily Report">
      <ExcelColumn label="Cluster Name" value={(r) => r.clusterName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}
      <ExcelColumn label="#Pwn" value={(r) => r.totalPiecesDetail.newPawn} />
      <ExcelColumn
        label="#Rdm"
        value={(r) => r.totalPiecesDetail.redeemedPawn}
      />
      <ExcelColumn
        label="P/R Diff"
        value={(r) =>
          r.totalPiecesDetail.newPawn - r.totalPiecesDetail.redeemedPawn
        }
      />
      <ExcelColumn
        label="Amt Pawn"
        value={(r) => r.totalPrincipalDetail.newPawn}
      />
      <ExcelColumn
        label="Amt Redm"
        value={(r) => r.totalPrincipalDetail.redeemedPawn}
      />
      <ExcelColumn
        label="Amt Diff"
        value={(r) =>
          r.totalPrincipalDetail.newPawn - r.totalPrincipalDetail.redeemedPawn
        }
      />
      <ExcelColumn
        label="Gross"
        value={(r) =>
          r.grossProfitDetail.totalNewPawnCharges +
          r.grossProfitDetail.totalRedeemedPawnCharges
        }
      />
      <ExcelColumn label="Total Pcs" value={(r) => r.totalPieces} />
      <ExcelColumn label="Total Amt" value={(r) => r.totalPrincipal} />
      <ExcelColumn
        label="Ave/Amt/Pc"
        value={(r) => r.averagePrincipalPerPiece}
      />
    </ExcelSheet>
  </ExcelFile>
);

export const DailyReportsExcelToRenderAreaComponent = (data, filename) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Daily Report">
      <ExcelColumn label="Area Name" value={(r) => r.areaName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}
      <ExcelColumn label="#Pwn" value={(r) => r.totalPiecesDetail.newPawn} />
      <ExcelColumn
        label="#Rdm"
        value={(r) => r.totalPiecesDetail.redeemedPawn}
      />
      <ExcelColumn
        label="P/R Diff"
        value={(r) =>
          r.totalPiecesDetail.newPawn - r.totalPiecesDetail.redeemedPawn
        }
      />
      <ExcelColumn
        label="Amt Pawn"
        value={(r) => r.totalPrincipalDetail.newPawn}
      />
      <ExcelColumn
        label="Amt Redm"
        value={(r) => r.totalPrincipalDetail.redeemedPawn}
      />
      <ExcelColumn
        label="Amt Diff"
        value={(r) =>
          r.totalPrincipalDetail.newPawn - r.totalPrincipalDetail.redeemedPawn
        }
      />
      <ExcelColumn
        label="Gross"
        value={(r) =>
          r.grossProfitDetail.totalNewPawnCharges +
          r.grossProfitDetail.totalRedeemedPawnCharges
        }
      />
      <ExcelColumn label="Total Pcs" value={(r) => r.totalPieces} />
      <ExcelColumn label="Total Amt" value={(r) => r.totalPrincipal} />
      <ExcelColumn
        label="Ave/Amt/Pc"
        value={(r) => r.averagePrincipalPerPiece}
      />
    </ExcelSheet>
  </ExcelFile>
);

export const DailyReportsExcelToRenderBranchComponent = (data, filename) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Daily Report">
      <ExcelColumn label="Branch Code" value={(r) => r.branchCode} />
      <ExcelColumn label="Branch Name" value={(r) => r.branchName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}
      <ExcelColumn label="#Pwn" value={(r) => r.totalPiecesDetail.newPawn} />
      <ExcelColumn
        label="#Rdm"
        value={(r) => r.totalPiecesDetail.redeemedPawn}
      />
      <ExcelColumn
        label="P/R Diff"
        value={(r) =>
          r.totalPiecesDetail.newPawn - r.totalPiecesDetail.redeemedPawn
        }
      />
      <ExcelColumn
        label="Amt Pawn"
        value={(r) => r.totalPrincipalDetail.newPawn}
      />
      <ExcelColumn
        label="Amt Redm"
        value={(r) => r.totalPrincipalDetail.redeemedPawn}
      />
      <ExcelColumn
        label="Amt Diff"
        value={(r) =>
          r.totalPrincipalDetail.newPawn - r.totalPrincipalDetail.redeemedPawn
        }
      />
      <ExcelColumn
        label="Gross"
        value={(r) =>
          r.grossProfitDetail.totalNewPawnCharges +
          r.grossProfitDetail.totalRedeemedPawnCharges
        }
      />
      <ExcelColumn label="Total Pcs" value={(r) => r.totalPieces} />
      <ExcelColumn label="Total Amt" value={(r) => r.totalPrincipal} />
      <ExcelColumn
        label="Ave/Amt/Pc"
        value={(r) => r.averagePrincipalPerPiece}
      />
    </ExcelSheet>
  </ExcelFile>
);
